/* @flow */

import * as React from 'react';
import { Link } from 'react-router-dom';
import { translate } from 'react-i18next';

//----------------------------------------------------------------------//
// MATERIAL UI                                                          //
//----------------------------------------------------------------------//

import Button from '@material-ui/core/Button';
import NavigationService from 'services/NavigationService';

//----------------------------------------------------------------------//
//----------------------------------------------------------------------//

@translate()
export default class AssignedToUser extends React.Component<*> {
  renderViewAllButton = (item: Object) => {
    const t: Function = this.props.t;
    const user: Object = this.props.user;
    const accountId: * = this.props.accountId;
    const url = NavigationService.formulateReportViewUri(`/${item.name}`, {
      page: 1,
      filters: [{ key: 'account', values: [accountId] }, { key: 'user', values: [user.id] }],
    });

    return (
      <Button
        color="primary"
        variant="contained"
        component={Link}
        disabled={item.count <= 0}
        to={url}
      >
        {t(`general:actions.view_${item.label}`, {
          count: item.count,
        })}
      </Button>
    );
  };

  render(): React.Element<*> {
    const t: Function = this.props.t;

    const assignedToUser: Array<*> = [
      {
        id: 1,
        name: 'assets',
        label: 'asset',
        count: this.props.user.assets_count,
      },
      {
        id: 2,
        name: 'projects',
        label: 'project',
        count: this.props.user.projects_count,
      },
    ];

    return (
      <React.Fragment>
        <h3>{t('general:users.assigned_to')}</h3>
        <table className="layout-table large-first-col">
          <tbody>
            {assignedToUser.map((item: Object) => (
              <tr key={item.id}>
                <td style={{ width: '130px' }}>{t(`general:${item.label}_plural`)}</td>
                <td className="layout-flex">
                  <div>
                    <span>{item.count}</span>
                    <span className="layout-button">{this.renderViewAllButton(item)}</span>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </React.Fragment>
    );
  }
}
